import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';
import webClient from '../../core/web_client';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { FOOD_PARTNER_ORDER_PATH } from '../../core/constants';

export const updateFoodPartnerOrderStatusAction = createAsyncThunk(
    'inventory/updateFoodPartnerOrderStatusAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.patch(`${ FOOD_PARTNER_ORDER_PATH }/${ data.id }?status=${ data.status }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const updateFoodPartnerOrderStatusSlice = createSlice({
    name: 'updateFoodPartnerOrderStatusSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(updateFoodPartnerOrderStatusAction.pending, () => STATE__API__STARTED);
        builder.addCase(updateFoodPartnerOrderStatusAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(updateFoodPartnerOrderStatusAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const updateFoodPartnerOrderStatusState = (state) => state.inventory.updateFoodPartnerOrderStatus;
export default updateFoodPartnerOrderStatusSlice.reducer;
